import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "position-relative" }
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "text-danger" }
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "position-relative" }
const _hoisted_17 = { class: "text-danger" }

import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import {
  CategoryStorePayload,
  CategoryStoreResponse,
} from "@/types/interface/category-store";
import { useCategoryStore } from "@/stores/master/category-store";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateCategoryStore',
  setup(__props) {

const idCategoryStore = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const categoryStore = useCategoryStore();
const detailCategoryStore = ref<CategoryStoreResponse>();

const validationSchema = toTypedSchema(
  zod.object({
    code: zod.string().nonempty({ message: "Code is required" }),
    name: zod.string().nonempty({ message: "Category Store Name is required" }),
    description: zod.string().nonempty({ message: "Description is required" }),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: code } = useField<string>("code");
const { value: name } = useField<string>("name");
const { value: description } = useField<string>("description");

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;
  const payloadCategoryStore: CategoryStorePayload = {
    code: code.value,
    name: name.value,
    description: description.value,
  };

  const responseApi = ref<any>();
  if (isEdit.value == true) {
    responseApi.value = await categoryStore.dispatchUpdate(
      idCategoryStore.value,
      payloadCategoryStore
    );
  } else {
    responseApi.value = await categoryStore.dispatchCreate(
      payloadCategoryStore
    );
  }

  const { success, message } = responseApi.value;
  if (success == true) {
    toast.success(
      isEdit.value
        ? "Category Store Successfully Updated"
        : "Category Store Successfully Added"
    );
    setTimeout(() => {
      isLoading.value = false;
      router.push("/master/category-store");
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const loadDetailCatgeoryStore = async () => {
  const { success, message } = await categoryStore.dispatchDetail(
    idCategoryStore.value
  );
  if (success) {
    detailCategoryStore.value = await categoryStore.category?.data;
    name.value = detailCategoryStore.value?.name;
    code.value = detailCategoryStore.value?.code;
    description.value = detailCategoryStore.value?.description;
  }
};

onMounted(() => {
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idCategoryStore.value = router.currentRoute.value.params.id.toString();
    loadDetailCatgeoryStore();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
            _createElementVNode("h3", { class: "mb-0" }, "Form Create Category Store"),
            _createElementVNode("a", {
              class: "btn btn-danger fw-semibold text-white px-3",
              type: "button",
              href: "/master/category-store"
            }, [
              _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }),
              _createTextVNode(" Back To List Category Store ")
            ])
          ], -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(BaseLoading, {
                key: 0,
                text: "Processing Data..."
              }))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "row g-3 needs-validation form"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[4] || (_cache[4] = _createElementVNode("label", {
                        for: "code",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Code "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          name: "code",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(code) ? (code).value = $event : null)),
                          placeholder: "Category Store Code",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(code)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(errors).code), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[5] || (_cache[5] = _createElementVNode("label", {
                        for: "name",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Category Store Name "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          name: "name",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
                          placeholder: "Category Store Name",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(name)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(errors).name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[6] || (_cache[6] = _createElementVNode("label", {
                        for: "description",
                        class: "form-label label text-secondary"
                      }, "Description", -1)),
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("textarea", {
                          name: "description",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(description) ? (description).value = $event : null)),
                          placeholder: "Description",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(description)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(errors).description), 1)
                    ])
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-12 mt-5" }, [
                    _createElementVNode("button", {
                      class: "btn btn-primary fw-semibold text-white py-2 px-3",
                      type: "submit"
                    }, " Save ")
                  ], -1))
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})